import { useState } from "react";

// How long the `--pixie-closed` class stays on after the Workspace closes. It
// only needs to outlast the controls' 0.25s fade-in (pixie-workspace.css).
const PIXIE_CONTROLS_FADE_MS = 300;

// 'leaving' while the Workspace's exit wipe runs, so the video's controls
// stay hidden until the video is fully uncovered; 'closed' for the beat
// the controls then fade back in (pixie-workspace.css).
export type PixieWorkspacePhase = "leaving" | "closed" | null;

type PhaseState = { pixieWorkspacePhase: PixieWorkspacePhase };

function createPixiePhase(setState: (state: PhaseState) => void) {
  const pixie = {
    closedTimer: null as ReturnType<typeof setTimeout> | null,
    onExit() {
      clearTimeout(pixie.closedTimer);
      setState({ pixieWorkspacePhase: "leaving" });
    },
    onExited() {
      setState({ pixieWorkspacePhase: "closed" });
      pixie.closedTimer = setTimeout(() => {
        pixie.closedTimer = null;
        setState({ pixieWorkspacePhase: null });
      }, PIXIE_CONTROLS_FADE_MS);
    },
    clearClosedTimer() {
      clearTimeout(pixie.closedTimer);
    },
  };
  return pixie;
}

/**
 * The Workspace exit phase Experience styles its container by, and the
 * PixieWorkspace onExit/onExited handlers (one identity per mount).
 */
export function usePixieWorkspacePhase() {
  // Class-style setState: always a new object, so every call re-renders.
  const [state, setState] = useState<PhaseState>({
    pixieWorkspacePhase: null,
  });
  const [pixie] = useState(() => createPixiePhase(setState));
  return { phase: state.pixieWorkspacePhase, pixie };
}
